module.exports = __webpack_public_path__ + "static/About me - desktop - 1-f6459af256d6dc2ba52ab5c3cbc71070.jpg";